import { joinClasses } from 'utils/componentStyles/style.utils';

const WeatherMapStaleDataNotice = ({ message, compact = false, className }) => (
  <div
    className={joinClasses('alert alert-warning m-0', compact ? 'py-1 small' : 'py-2', className)}
    role="alert"
  >
    {message}
  </div>
);

export default WeatherMapStaleDataNotice;
